import React, { useState } from "react";
import styles from "./CustomCheckboxesLocal.module.scss";
import Text from "components/text/Text";
import { getAllClassNames } from "helpers";
import { visitDaysOptionsAriaLabel } from "assets/constants";

type ICheckBoxOptions = {
  label: string;
  value: string;
}
type ICustomCheckboxes = React.ComponentProps<"div"> & {
  title?: string;
  isFlex?: boolean;
  limitWidth?: boolean;
  options?: ICheckBoxOptions[];
  selectedCheckboxes?: string[];
  onSetSelected?: (selected: string[]) => void;
  isSpecialAriaLabel?: boolean;
  //transformItems?: (items: RefinementListItem[]) => RefinementListItem[];
  //sortBy?: (items: RefinementListItem[]) => RefinementListItem[];
};

export const CustomCheckboxesLocal = ({
  title,
  isFlex,
  limitWidth,
  options,
  selectedCheckboxes,
  onSetSelected,
  isSpecialAriaLabel=false,
  //transformItems,
  //sortBy,
}: ICustomCheckboxes) => {
  const itemsLocal = options;
  const [selected, setSelected] = useState<string[]>(selectedCheckboxes || []);

  const isSelectedLocalData = (value: string) =>
    selected.includes(value);

  const onSelectLocalData = (value: string) => {
    setSelected((prevState) => {
      if (prevState.includes(value)) {
        onSetSelected && onSetSelected(prevState.filter((selectedVal) => selectedVal !== value));
        return prevState.filter((selectedVal) => selectedVal !== value);
      } else {
        onSetSelected && onSetSelected([...prevState, value]);
        return [...prevState, value];
      }
    });

  };

  return (
    <fieldset className={styles.container}>
      {title && <Text className={styles.title} text={title} isLegend/>}
      <div className={"ais-RefinementList"}>
        <ul
          className={getAllClassNames([
            "ais-RefinementList-list",
            isFlex && styles.list,
            limitWidth && styles.limitWidth,
          ])}          
        >
          {itemsLocal?.map((item, index) => (
            <li
              key={item.value}
              className={getAllClassNames([
                styles.item,
                "ais-RefinementList-item",
                isSelectedLocalData(item.value) && "ais-RefinementList-item--selected",
              ])}
            >
              <label className={"ais-RefinementList-label"} aria-label={isSpecialAriaLabel ? visitDaysOptionsAriaLabel[index] : ''}>
                <input
                  className={getAllClassNames([
                    "ais-RefinementList-checkbox",
                    styles.checkbox,
                  ])}
                  type="checkbox"
                  value={item.value}
                  checked={isSelectedLocalData(item.value)}
                  onChange={() => {
                    onSelectLocalData(item.value);
                  }}
                />
                <span
                  className={getAllClassNames([
                    "ais-RefinementList-labelText",
                    styles.labelText,
                  ])}
                >
                  {item.label}
                </span>
              </label>
            </li>
          ))}
        </ul>
      </div>
    </fieldset>
  );
};
